module.exports = __webpack_public_path__ + "static/media/LockIcon.637bdd48.svg";